import React from "react";
import UserProjects from "../Static Files/UserProjects.json";
import axios from "axios";
import authHeader from "../Services/auth-header";

import { baseURLFilterColor, baseURLFilterPatternSewing, baseURLFilterTypeSewing, baseURLFilterPrice, baseURLFilterOpacitySewing } from "../config/api";
let tempData = {
  "0303": {
    pattern: [],
    type: [],
  },
  "0324": {
    pattern: [
      { value: "Plains", label: "Plains", labelFa: "ساده" },
      { value: "Prints&Patterns", label: "Prints&Patterns", labelFa: "نقش‌دار چاپی" },
      { value: "Sheers", label: "Sheers", labelFa: "حریر" },
      { value: "Textures", label: "Textures", labelFa: "بافت‌دار" },
      { value: "Children's Designs", label: "Children's Designs", labelFa: "کودکانه" },
    ],
    type: [
      { value: "Light Filtering", label: "Light Filtering", labelFa: "نور ملایم" },
      { value: "Room Darkening", label: "Room Darkening", labelFa: "نور کم" },
    ],
  },
  "0325": {
    pattern: [
      { value: "Plains", label: "Plains", labelFa: "ساده" },
      { value: "Prints&Patterns", label: "Prints&Patterns", labelFa: "طرحدار" },
      { value: "Sheers", label: "Sheers", labelFa: "توری" },
      { value: "Textures", label: "Textures", labelFa: "بافت ويژه" },
      { value: "Children's Designs", label: "Children's Designs", labelFa: "بچه گانه" },
    ],
    type: [
      { value: "Light Filtering", label: "Light Filtering", labelFa: "روشن" },
      { value: "Room Darkening", label: "Room Darkening", labelFa: "تاريک" },
    ],
  },
  "0326": {
    pattern: [],
    type: [],
  },
  "0099": {
    pattern: [],
    type: [],
  },
  "0097": {
    pattern: [],
    type: [],
  },
};

async function GetSewingFilters(id, modelId) {
  if (id === 1) {
    return await new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterColor)
        .then((response) => {
          let tempObj = {
            en: [],
            fa: [],
          };

          let promise2 = new Promise((resolve, reject) => {
            response.data
              .sort((a, b) => a["ColorENName"].localeCompare(b["ColorENName"]))
              .forEach((object1, index) => {
                tempObj["en"][index] = { value: object1["ColorId"], label: object1["ColorENName"] };
                tempObj["fa"][index] = { value: object1["ColorId"], label: object1["ColorName"] };

                if (index === response.data.length - 1) {
                  resolve();
                }
              });
          });
          promise2.then(() => {
            resolve(tempObj);
          });
        })
        .catch((err) => {
          resolve({
            en: [],
            fa: [],
          });
        });
    });
  } else if (id === 2) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${baseURLFilterPatternSewing}?modelId=${modelId}`)
        .then((response) => {
          let tempObj = {
            en: [],
            fa: [],
          };

          let promise2 = new Promise((resolve, reject) => {
            response.data.forEach((object1, index) => {
              tempObj["en"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["EnTitle"],
              };
              tempObj["fa"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["FAName"],
              };

              if (index === response.data.length - 1) {
                resolve();
              }
            });
            // tempData[modelId]["pattern"].forEach((object1, index) => {
            //     tempObj["en"][index] = {value: object1["value"], label: object1["label"]};
            //     tempObj["fa"][index] = {value: object1["value"], label: object1["labelFa"]};

            //     if (index === tempData[modelId]["pattern"].length - 1) {
            //         resolve();
            //     }
            // });
          });
          promise2.then(() => {
            resolve(tempObj);
          });
        })
        .catch((err) => {
          resolve({
            en: [],
            fa: [],
          });
        });
    });
  } else if (id === 3) {
    return await new Promise((resolve, reject) => {
      axios
      .get(`${baseURLFilterTypeSewing}?modelId=${modelId}`)
        .then((response) => {
          let tempObj = {
            en: [],
            fa: [],
          };

          let promise2 = new Promise((resolve, reject) => {
            response.data.forEach((object1, index) => {
              tempObj["en"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["EnTitle"],
              };
              tempObj["fa"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["FAName"],
              };

              if (index === response.data.length - 1) {
                resolve();
              }
            });
            // tempData[modelId]["type"].forEach((object1, index) => {
            //     tempObj["en"][index] = {value: object1["value"], label: object1["label"]};
            //     tempObj["fa"][index] = {value: object1["value"], label: object1["labelFa"]};

            //     if (index === tempData[modelId]["type"].length - 1) {
            //         resolve();
            //     }
            // });
          });
          promise2.then(() => {
            resolve(tempObj);
          });
        })
        .catch((err) => {
          resolve({
            en: [],
            fa: [],
          });
        });
    });
  } else if (id === 5) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${baseURLFilterPatternSewing}?modelId=${modelId}`)
        .then((response) => {
          let tempObj = {
            en: [],
            fa: [],
          };

          let promise2 = new Promise((resolve, reject) => {
            response.data.forEach((object1, index) => {
              tempObj["en"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["EnTitle"],
              };
              tempObj["fa"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["FAName"],
              };

              if (index === response.data.length - 1) {
                resolve();
              }
            });
            // tempData[modelId]["pattern"].forEach((object1, index) => {
            //     tempObj["en"][index] = {value: object1["value"], label: object1["label"]};
            //     tempObj["fa"][index] = {value: object1["value"], label: object1["labelFa"]};

            //     if (index === tempData[modelId]["pattern"].length - 1) {
            //         resolve();
            //     }
            // });
          });
          promise2.then(() => {
            resolve(tempObj);
          });
        })
        .catch((err) => {
          resolve({
            en: [],
            fa: [],
          });
        });
    });
  } else if (id === 6) {
    return await new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterTypeSewing)
        .then((response) => {
          let tempObj = {
            en: [],
            fa: [],
          };

          let promise2 = new Promise((resolve, reject) => {
            response.data.forEach((object1, index) => {
              tempObj["en"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["EnTitle"],
              };
              tempObj["fa"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["FAName"],
              };

              if (index === response.data.length - 1) {
                resolve();
              }
            });
            // tempData[modelId]["type"].forEach((object1, index) => {
            //     tempObj["en"][index] = {value: object1["value"], label: object1["label"]};
            //     tempObj["fa"][index] = {value: object1["value"], label: object1["labelFa"]};

            //     if (index === tempData[modelId]["type"].length - 1) {
            //         resolve();
            //     }
            // });
          });
          promise2.then(() => {
            resolve(tempObj);
          });
        })
        .catch((err) => {
          resolve({
            en: [],
            fa: [],
          });
        });
    });
  } else if (id === 7) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${baseURLFilterOpacitySewing}?modelId=${modelId}`)
        .then((response) => {
          let tempObj = {
            en: [],
            fa: [],
          };

          let promise2 = new Promise((resolve, reject) => {
            response.data.forEach((object1, index) => {
              tempObj["en"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["EnTitle"],
              };
              tempObj["fa"][index] = {
                value: object1["BaseTypeDetailId"],
                label: object1["FAName"],
              };

              if (index === response.data.length - 1) {
                resolve();
              }
            });
            // tempData[modelId]["type"].forEach((object1, index) => {
            //     tempObj["en"][index] = {value: object1["value"], label: object1["label"]};
            //     tempObj["fa"][index] = {value: object1["value"], label: object1["labelFa"]};

            //     if (index === tempData[modelId]["type"].length - 1) {
            //         resolve();
            //     }
            // });
          });
          promise2.then(() => {
            resolve(tempObj);
          });
        })
        .catch((err) => {
          resolve({
            en: [],
            fa: [],
          });
        });
    });
  } else {
    return await new Promise((resolve, reject) => {
      axios
        .get(baseURLFilterPrice)
        .then((response) => {
          let tempObj = {
            en: [],
            fa: [],
          };

          let promise2 = new Promise((resolve, reject) => {
            response.data.forEach((object1, index) => {
              tempObj["en"][index] = {
                value: object1["ProductPriceLevelId"],
                label: object1["LevelEnTitle"],
              };
              tempObj["fa"][index] = {
                value: object1["ProductPriceLevelId"],
                label: object1["LevelTitle"],
              };

              if (index === response.data.length - 1) {
                tempObj["en"][index + 1] = { value: "Sale", label: "Sale" };
                tempObj["fa"][index + 1] = { value: "Sale", label: "حراجی" };
                resolve();
              }
            });
          });
          promise2.then(() => {
            resolve(tempObj);
          });
        })
        .catch((err) => {
          resolve({
            en: [],
            fa: [],
          });
        });
    });
  }
}

export default GetSewingFilters;
